<template>
  <div>
    <ExcursionCoverBlock
      :current-tag="filtersStore.state.tag__slugs || ''"
      :page="props.page"
      :slug="props.slug"
      :geo-object="geoObject"
      :tags
    />

    <ExcursionFiltersBlock
      :currency-code="props.currencyCode"
      :page="props.page"
      :default-sogu-fields="props.defaultSoguFields"
      :slug="props.slug"
      @updated="emit('filtersUpdated')"
    />

    <ExcursionRubricsBlock
      :slug="props.slug"
      :default-sogu-fields="props.defaultSoguFields"
      :city-tags="cityTags"
      @tagChanged="emit('tagChanged', $event)"
    />

    <ExcursionSmallOutputBlock
      :key="props.currencyCode"
      :tags
      :currency-code="props.currencyCode"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  // Widgets
  import { ExcursionRubricsBlock } from '@/widgets/rubricsBlock/excursion';
  import { ExcursionFiltersBlock } from '@/widgets/filtersBlock/excursion';
  import { ExcursionSmallOutputBlock } from '@/widgets/smallOutputBlock/excursion';
  import { ExcursionCoverBlock } from '@/widgets/coverBlock/excursion';

  // Features
  import { useCityTagsCollectionsExperiment } from '@/features/experiments';

  // Entities
  import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
  import { useCityTag } from '@/entities/tag/api/useCityTag.ts';
  import type { ExtendedPartTagType } from '@/entities/rubrics';

  // Shared and external imports
  import type { CityInfo, CityTag } from '@/shared/api/experience';
  import type { ContextGeoSubject } from '@/shared/types/geography';
  import type { CurrencyCode } from '@/shared/lib/currency';

  interface Props {
    slug: string;
    page: number;
    geoObject: CityInfo;
    defaultSoguFields: ContextGeoSubject;
    currencyCode: CurrencyCode;
  }

  const props = withDefaults(defineProps<Props>(), {});

  const emit = defineEmits<{
    filtersUpdated: [];
    tagChanged: [tag: ExtendedPartTagType];
  }>();

  const filtersStore = useExcursionFiltersStore();

  const { isExpActive } = useCityTagsCollectionsExperiment();
  const { cityTags } = useCityTag({
    slug: computed(() => props.slug),
    enabled: computed(() => true),
    sorting: isExpActive.value ? 'ranking_mab' : '-popularity',
  });

  const tags = computed<CityTag[]>(() => {
    return cityTags.value ?? [];
  });

  // Обработка 404 для /experience/Saint_Petersburg/not-existing-rubric-1234/
  // watchOnce(
  //   () => tags.value,
  //   () => {
  //     const { tag } = route.params;

  //     if (!tag) {
  //       return;
  //     }

  //     const isTagExist = tags.value.some((tagItem) => tag.includes(tagItem.slug as string));

  //     loaderStore.is404 = !isTagExist;
  //   },
  // );

  watchEffect(() => {
    filtersStore.pageParams.city = props.slug;
  });
</script>
